const requireIcons = require.context('./icons', false, /\.svg$/)

const CustomIcons = {}

requireIcons.keys().forEach(filePath => {
  const iconName = filePath.replace('./', '').replace('.svg', '')
  CustomIcons[iconName] = {
    functional: true,
    render(h, { data }) {
      return h('img', {
        attrs: {
          src: requireIcons(filePath),
          alt: iconName,
          width: data.props?.size || 24,
          height: data.props?.size || 24,
        },
        style: 'cursor: pointer;',
        on: data.on,
      })
    },
  }
  
})

export default CustomIcons
